if (document.querySelector("#about-us")) {
    (function AboutUs() {
        var holders = document.querySelectorAll("div.holder");
        var holderContainer = document.querySelector("section.holder-container");
        window.addEventListener("scroll", function () {
            var pixels = window.pageYOffset;
            holders.forEach(function (holder, index) {
                var step = window.innerHeight;
                var start = -130 * index; // start at different angles, 0, -130, -260, etc
                var diff = 130; // how much to turn
                var angle = Math.min(0, start + diff * (pixels / step));
                var fold = holder.querySelector("div");
                fold.style.transform = "rotateX(" + angle + "deg)";
            });
        });
        window.addEventListener('scroll', function () {
            var scroll = window.pageYOffset;
            var images = document.getElementsByClassName("blur-image");
            var maxBlur = 30;
            var blurAmount = Math.min(scroll / 1, maxBlur);
            for (var i = 0; i < images.length; i++) {
                //@ts-ignore
                images[i].style.filter = 'blur(' + blurAmount + 'px)';
            }
        });
        var scrollSections = document.querySelectorAll("div.scroll-cool-4");
        window.addEventListener("scroll", function () {
            // given to use by the browser
            var scrollPosition = window.pageYOffset;
            // for each span, we're doing something slightly different
            // so lets do a loop for each one
            scrollSections.forEach(function (section, index) {
                var span = section.querySelector("span");
                var spanAir = document.querySelector("span.air-scale");
                // move each scroll position per span up by 2000px
                // this gives us 2000px per text to play with
                //@ts-ignore
                var spanScrollPosition = scrollPosition - section.offsetTop;
                // if we're above 1000px in each span's scroll
                if (spanScrollPosition > 1000) {
                    // fade out, starting at 1 going to 0 opacity
                    // - 1000 as we need to factor it where we started
                    // 0.001 is just speed of opacity change
                    //@ts-ignore
                    span.style.opacity = 1 - ((spanScrollPosition - 1000) * 0.001);
                }
                else {
                    // 0.001 is just speed of opacity change
                    //@ts-ignore
                    span.style.opacity = spanScrollPosition * 0.001;
                }
                // -0.02 is speed of movement change
                // minus as we're going up page as we scroll down
                var y = spanScrollPosition * -0.02;
                var x = spanScrollPosition * 0.02;
                span.style.transform = "translate(0, " + y + "px)";
                //@ts-ignore
            });
        });
    })();
}
